// actionLogKinds — Typad enum över action-kinds som kan loggas.
//
// PII-policy: endast ids, kind, och numeriska skalärer loggas. User-typed
// text (block-names, beskrivningar, fil-innehåll) logggas ALDRIG. Se
// actionLogRedact för enforcement.

export const ACTION_KINDS = [
  // Canvas mutations
  'canvas.block.create',
  'canvas.block.move',
  'canvas.block.delete',
  'canvas.block.update',
  'canvas.connector.create',
  'canvas.connector.delete',
  'canvas.connector.update',
  'canvas.group.create',
  'canvas.group.update',
  'canvas.group.delete',
  'canvas.group.collapse',
  'canvas.group.expand',
  'canvas.layer.enter',
  'canvas.layer.exit',
  'canvas.block.convertToLayer',
  'canvas.clear',

  // Workflow lifecycle
  'workflow.save',
  'workflow.load',
  'workflow.rename',
  'workflow.import',
  'workflow.export',
  'workflow.undo',
  'workflow.redo',

  // Multi-sheet
  'sheet.add',
  'sheet.remove',
  'sheet.switch',
  'sheet.rename',
  'sheet.reorder',

  // Navigation
  'nav.route',
  'nav.focus',

  // Dialogs / panels
  'dialog.open',
  'dialog.close',

  // Errors
  'error.caught',

  // Onboarding / tour
  'tour.start',
  'tour.step',
  'tour.end',
  'tour.skip',

  // AI interactions (non-content)
  'ai.request',
  'ai.response',

  // Meta
  'log.clear',
] as const;

export type ActionKind = typeof ACTION_KINDS[number];

/** Returnera true om strängen är en giltig ActionKind. */
export function isActionKind(s: string): s is ActionKind {
  return (ACTION_KINDS as readonly string[]).includes(s);
}

/** Kategori-grupp för filtrering i UI. */
export type ActionCategory = 'canvas' | 'workflow' | 'sheet' | 'nav' | 'dialog' | 'error' | 'tour' | 'ai' | 'log';

export function categoryOf(kind: ActionKind): ActionCategory {
  const prefix = kind.split('.')[0];
  return prefix as ActionCategory;
}

export function listKindsInCategory(category: ActionCategory): ActionKind[] {
  return ACTION_KINDS.filter(k => categoryOf(k) === category);
}
